import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { WINDOW } from '@ng-toolkit/universal';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { WebsiteService } from 'src/app/_services/website.service';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-api',
  templateUrl: './api.component.html',
  styleUrls: ['./api.component.scss']
})
export class APIComponent implements OnInit, AfterViewInit {
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  

  constructor(private titleService: Title,
    private toastr: ToastrService,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    @Inject(WINDOW) private window: Window,
    private networkCall: WebsiteService,
    private fb: FormBuilder,
    private router: Router,
    public loadScript: LoadScriptService
  ) { 

    
  }
  
  
  ngOnInit() {
    this.titleService.setTitle("Trinkaの文法チェックAPI | シンプルで高速、パワフルな文法チェッカー");
    this.metaTagService.updateTag({ name: 'description', content: "Trinkaの文法チェックAPIをお客様開発のアプリに統合して、エンドユーザーにリアルタイムの英文チェックを" });
    this.metaTagService.updateTag({ property: 'og:title', content: "Trinkaの文法チェックAPI | シンプルで高速、パワフルな文法チェッカー" });
    this.metaTagService.updateTag({ property: 'og:description', content: "Trinkaの文法チェックAPIをお客様開発のアプリに統合して、エンドユーザーにリアルタイムの英文チェックを" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/enterprise/grammar-checker-api' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/trinka-api.svg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: "Trinkaの文法チェックAPI | シンプルで高速、パワフルな文法チェッカー" });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinkaの文法チェックAPIをお客様開発のアプリに統合して、エンドユーザーにリアルタイムの英文チェックを" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/trinka-api.svg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/enterprise/grammar-checker-api' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/grammar-checker-api' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/grammar-checker-api' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/grammar-checker-api' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/grammar-checker-api' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/grammar-checker-api' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/grammar-checker-api' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/grammar-checker-api' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/grammar-checker-api' });

    this.country = localStorage.getItem("country")? localStorage.getItem("country"):"en";
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  ngAfterViewInit() {
    
  }

  
}
